let cachedKamExpVariant: string | null = null;
let initialized = false;
let logged = false;

export const initKamExpVariant = (): void => {
  if (initialized) {
    return;
  }
  initialized = true;
  const raw = new URLSearchParams(window.location.search).get('kamExpVariant');
  cachedKamExpVariant = raw && raw.length > 0 ? raw : null;
};

export const getKamExpVariant = (): string | null => {
  if (!initialized) {
    initKamExpVariant();
  }
  return cachedKamExpVariant;
};

export const withExpVariant = <T extends object>(payload: T): T => {
  const value = getKamExpVariant();
  if (value) {
    return { ...payload, trident_variant_string: value };
  }
  return payload;
};

export const logKamExpVariantOnce = (): void => {
  if (logged) {
    return;
  }
  logged = true;
  const value = getKamExpVariant();
  if (value) {
    // eslint-disable-next-line no-console
    console.log(`[GA][TRACKING] kamExpVariant=${value}`);
  } else {
    // eslint-disable-next-line no-console
    console.log('[GA][TRACKING] kamExpVariant not present in URL');
  }
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const __resetKamExpVariantForTests = (): void => {
  cachedKamExpVariant = null;
  initialized = false;
  logged = false;
};
